import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {isLoggedIn} from '../../reducer';


const PublicRoute = ({ component: Component, loggedIn, ...rest }) => (
    <Route {...rest} render={props => (
        !loggedIn
            ? <Component {...props}>{props.children}</Component>
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )} />
);

const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state)
});


export default connect(
    mapStateToProps
)(PublicRoute)



// WEBPACK FOOTER //
// ./src/components/PublicRoute/index.js